module.exports = require("@nestjs/serve-static");